import React from 'react';
import { motion } from 'framer-motion';
export function Navbar() {
  return <motion.nav initial={{
    y: -20,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    duration: 0.5,
    ease: 'easeOut'
  }} className="fixed top-0 left-0 right-0 z-50 bg-cream/80 backdrop-blur-md border-b border-warmBrown/5" data-id="element-134">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center relative" data-id="element-135">
        <div className="flex items-center gap-2 cursor-pointer" data-id="element-136">
          <img src="https://cdn.magicpatterns.com/uploads/mMVV4XoPmsr1QmNTgf4DWX/icon.png" alt="Pawchi logo" className="w-9 h-9 rounded-lg" data-id="element-137" />
          <span className="font-logo font-semibold text-2xl text-warmBrown tracking-tight" data-id="element-138">
            Pawchi
          </span>
        </div>

        <div className="hidden md:flex items-center gap-8 absolute left-1/2 -translate-x-1/2" data-id="element-139">
          <a href="#how-it-works" className="font-medium text-warmBrown/70 hover:text-peach transition-colors" data-id="element-140">
            How It Works
          </a>
          <a href="#features" className="font-medium text-warmBrown/70 hover:text-peach transition-colors" data-id="element-141">
            Features
          </a>
          <a href="#testimonials" className="font-medium text-warmBrown/70 hover:text-peach transition-colors" data-id="element-142">
            Stories
          </a>
        </div>
      </div>
    </motion.nav>;
}